<template>
  <div class="tournament-single">
    <div class="container">
      <div class="row">
        <div class="col col-md-6">
          <div v-if="isNewRecord">
            <h1>Quero fazer meu campeonato no QUEOTA.club</h1>

            <p class>
              Você consegue rodar seu campeonato completo usando o QUEOTA.club.
              <br>Oferecemos o pacote completo, para você não se preocupar com nada além de trazer os times.
            </p>

            <ul class="lead">
              <li>Não precisa configurar nada</li>
              <li>Servidores próprios, de última geração</li>
              <li>Anticheater leve e MUITO BOM</li>
              <li>Página personalizada para o seu campeonato</li>
              <li>Inscrições (pagas ou não)</li>
              <!-- <li>Tabela e grupos automatizados</li> -->
              <li>Gestão fácil de partidas</li>
              <li>GOTV com delay para seu público</li>
              <li>Espectador nos servidores para poder transmitir as partidas</li>
            </ul>

            <p class>Pra que ficar se batendo para gerenciar um campeonato? Vem com a gente!</p>
          </div>

          <div v-else>
            <h2>editando campeonato</h2>
          </div>
        </div>
        <div class="col col-md-6">
          <b-form @submit="onSubmit">
            <b-form-group label="Nome do Campeonato">
              <b-form-input v-model="tournament.name" required></b-form-input>
            </b-form-group>

            <b-form-group description label="Descrição do Campeonato">
              <ckeditor required :editor="editor" v-model="tournament.about" :config="editorConfig"></ckeditor>
            </b-form-group>

            <b-form-group label="Data de abertura de inscrições">
              <datetime
                required
                v-model="tournament.checkin_starts_at"
                type="datetime"
                placeholder="a partir desta data os times conseguem se inscrever"
                :min-datetime="minDate"
                :max-datetime="maxDate"
                :minute-step="60"
                input-class="form-control"
                class="mb-3"
              ></datetime>
            </b-form-group>

            <b-form-group label="Data de início">
              <datetime
                required
                v-model="tournament.starts_at"
                type="datetime"
                placeholder="início das partidas"
                :min-datetime="minDate"
                :max-datetime="maxDate"
                :minute-step="60"
                input-class="form-control"
                class="mb-3"
              ></datetime>
            </b-form-group>

            <b-form-group
              label="Número de vagas"
              description="para campeonatos maiores entre em contato"
            >
              <b-form-input v-model="tournament.slots" required type="number" min="8" max="32"></b-form-input>
            </b-form-group>

            <b-form-group label="Inscrição (preço)">
              <b-form-input v-model="tournament.inscription_price" required placeholder="R$ 50"></b-form-input>
            </b-form-group>

            <b-form-checkbox
              v-model="tournament.payments_handled_by_us"
              description="mais informações em nosso Suporte (link no menu)"
              :value="true"
              :unchecked-value="false"
            >Pagamentos e inscrições gerenciados pelo QUEOTA.club?</b-form-checkbox>

            <div v-if="!tournament.payments_handled_by_us">
              <b-form-group label="Link para inscrições">
                <b-form-input
                  v-model="tournament.inscription_url"
                  placeholder="https://exemplo.com"
                ></b-form-input>
              </b-form-group>
            </div>

            <b-form-group label="Link para tabela">
              <b-form-input v-model="tournament.brackets_url" placeholder="https://exemplo.com"></b-form-input>
            </b-form-group>

            <b-form-group label="Tipo do Campeonato">
              <b-form-select v-model="tournament.tournament_format" :options="tournamentFormats"></b-form-select>
            </b-form-group>

            <b-form-group label="Formato">
              <b-form-textarea
                id="textarea"
                required
                v-model="tournament.tournament_format_extra"
                placeholder="qual o formato do campeonato? upper e lower? simples? grupos? mata mata? md1? md3? descreva bem"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>

            <b-form-group label="Premiação">
              <b-form-textarea
                id="textarea"
                v-model="tournament.prize_info"
                placeholder="detalhes sobre prêmiação para primeiro, segundo, terceiro, etc"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>

            <b-form-group label="Nome do Organizador">
              <b-form-input
                v-model="tournament.org_name"
                required
                placeholder="para contato de nossa equipe"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Email do Organizador">
              <b-form-input
                v-model="tournament.org_email"
                required
                placeholder="para contato de nossa equipe"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Telefone do Organizador">
              <b-form-input
                v-model="tournament.org_cellphone"
                required
                placeholder="para contato de nossa equipe"
              ></b-form-input>
            </b-form-group>

            <b-form-textarea
              id="textarea"
              v-model="tournament.extra_info"
              placeholder="Informações extras (para nossa equipe)"
              rows="3"
              max-rows="6"
            ></b-form-textarea>

            <b-button type="submit" variant="primary" v-html="buttonLabel"></b-button>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>

</style>

<script>
import PageHeader from "@/components/PageHeader";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { DateTime } from "luxon";
export default {
  name: "TournamentCreate",
  data() {
    return {
      tournament: {
        featured_image: "",
        title: "",
        id: 0,
        cover: {},
        badge: {},
        matches: []
      },
      tournament: {
        name: "",
        about: "",
        tournament_format: "",
        starts_at: "",
        checkin_starts_at: "",
        slots: 32,
        inscription_price: "",
        prize_price: "",
        payments_handled_by_us: false,
        brackets_handled_by_us: false,
        inscription_url: "",
        brackets_url: "",
        tournament_format_extra: "",
        extra_info: "",
        prize_info: "",
        user_id: "",
        org_cellphone: "",
        org_email: "",
        org_name: ""
      },
      tournamentFormats: [
        { text: "1x1", value: "onexone" },
        { text: "3x3", value: "threexthree" },
        { text: "5x5", value: "onexone" }
      ],
      editor: ClassicEditor,
      editorData: "<p>descrição do campeonato</p>",
      editorConfig: {
        toolbar: {
          items: ["bold", "italic", "link", "undo", "redo"]
        }
      }
    };
  },
  metaInfo() {
    return {
      title: `Crie seu Campeonato`
    };
  },
  computed: {
    isNewRecord: function() {
      return !(this.$route.params.id !== undefined);
    },
    buttonLabel: function() {
      return this.isNewRecord ? "Criar campeonato" : "Salvar";
    },
    minDate: function() {
      return DateTime.local()
        .setZone("America/Sao_Paulo")
        .plus({ minutes: 10 })
        .toISODate();
    },
    maxDate: function() {
      return DateTime.local()
        .setZone("America/Sao_Paulo")
        .plus({ days: 120 })
        .toISODate();
    }
  },
  methods: {
    initialize() {
      if (this.$route.params.id !== undefined)
        this.$http
          .get(`tournaments/${this.$route.params.id}.json`)
          .then(response => (this.tournament = response.data));
    },
    onSubmit(evt) {
      evt.preventDefault();
      if (this.$route.params.id !== undefined) {
        this.$http
          .put(`tournaments/${this.$route.params.id}.json`, {
            tournament: this.tournament
          })
          .then(response => {
            this.$router.push(`/tournaments/${response.data.slug}`);
            this.$notify({
              group: "all",
              title: "Campeonato atualizado",
              type: "success"
            });
          });
      } else {
        this.$http
          .post(`tournaments.json`, { tournament: this.tournament })
          .then(response => {
            this.$router.push(`/tournaments/${response.data.slug}`);
            this.$notify({
              group: "all",
              title:
                "Campeonato criado com sucesso. Para abrir as inscrições e tornar público confirme o pagamento.",
              type: "success",
              duration: -1000
            });
          });
      }
    }
  },
  mounted() {
    this.initialize();
  },
  watch: {
    "$route.params.id": function(id) {
      this.initialize();
    }
  },
  components: {
    PageHeader
  }
};
</script>
